import React, { useState } from 'react';
import { Container, TextField, Button, Typography } from '@mui/material';
import { forgotPassword, confirmPasswordReset } from './cognito';
import { useNavigate } from 'react-router-dom';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [step, setStep] = useState('request'); // 'request' or 'confirm'
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleRequestReset = async () => {
    try {
      const response = await forgotPassword(email);
      setMessage(response.message);
      setStep('confirm');
    } catch (error) {
      setMessage(error.message);
    }
  };

  const handleConfirmReset = async () => {
    if (newPassword !== confirmPassword) {
      setMessage('Passwords do not match');
      return;
    }

    try {
      const response = await confirmPasswordReset(email, code, newPassword);
      setMessage(response.message);
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>
        Reset Password
      </Typography>

      {step === 'request' ? (
        <>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
          />
          <Button
            variant="contained"
            onClick={handleRequestReset}
            fullWidth
            sx={{ mt: 2 }}
          >
            Request Reset Code
          </Button>
        </>
      ) : (
        <>
          <TextField
            label="Reset Code"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="New Password"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Confirm New Password"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            fullWidth
            margin="normal"
          />
          <Button
            variant="contained"
            onClick={handleConfirmReset}
            fullWidth
            sx={{ mt: 2 }}
          >
            Reset Password
          </Button>
        </>
      )}

      {message && (
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            color: message.toLowerCase().includes('success') ? 'green' : 'red',
          }}
        >
          {message}
        </Typography>
      )}
    </Container>
  );
}

export default ResetPassword;